<template>
	<v-card
		class="technique-info-card-wrapper"
		flat
	>
		<div
			v-if="title"
			class="pt-3 px-4 d-flex align-center"
		>
			<slot
				name="title"
				v-bind="{ title }"
			>
				<span class="ao-c2-medium ao-text-secondary-color-700">{{ title }}</span>
			</slot>
			<v-menu v-if="info">
				<template v-slot:activator="{ props }">
					<div
						v-bind="props"
						style="z-index: 1"
						class="d-flex align-center"
					>
						<ao-icon
							v-bind="props"
							class="btn-info cursor-pointer ao-p4-regular"
							iconName="info"
						/>
					</div>
				</template>
				<v-card
					width="287"
					class="technique-info-card-menu pa-4"
				>
					<ao-icon
						class="btn-close"
						iconName="close"
					/>
					<slot name="info" />
				</v-card>
			</v-menu>
		</div>

		<ao-icon-btn
			v-if="!edit"
			size="24"
			iconName="pen"
			variant="flat"
			class="edit-btn"
			@click="onEdit"
		/>

		<slot />
	</v-card>
</template>

<script>
export default {
	name: 'PassportInfoCard',
	props: {
		heading: Boolean,
		edit: Boolean,
		info: Boolean,
		title: String,
	},
	emits: {
		edit: null,
	},
	setup(props, { emit }) {
		const onEdit = () => {
			emit('edit')
		}
		return {
			onEdit,
		}
	},
}
</script>

<style scoped lang="scss">
.technique-info-card-wrapper {
	position: relative;

	.btn-info {
		color: rgb(var(--v-theme-primary));
		margin-left: 6px;
		font-size: 12px;
	}

	.edit-btn {
		position: absolute;
		font-size: 12px;
		color: #576674;
		background: #dee6e8;
		z-index: 2;
		top: 8px;
		right: 8px;
	}
}

.technique-info-card-menu {
	.btn-close {
		position: absolute;
		top: 8px;
		right: 9px;
	}
}
</style>
